import { render } from "./NextSectionButton.vue?vue&type=template&id=42af198a"
import script from "./NextSectionButton.vue?vue&type=script&lang=js"
export * from "./NextSectionButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__